module.exports = __webpack_public_path__ + "media/components/Sponsors/FormTags/Categories/20-7059d182046ba8e08885932c838dba3b.png";